(function (upp) {
    'use strict';

    var _forEach = angular.forEach;

    //PLUGIN FOR MODULES:
    // * ESHOP
    // * PROMOTIONS

    upp.factory('productsDao', ['$q', 'appi', 'product',
        function ($q, appi, Product) {
            function ProductsDao(urlApiRestServer) {
                var self = this;
                self.urlApiRestServer = urlApiRestServer;
                self.$q = $q;
                self.httpGet = appi.http.get;
            }

            /**
             * Returns the list of available products in the eshop and the currency
             *
             * @method listProducts
             * @param {Object} params Parameters used to filter(filter.categoryId), order(sort.index && sort.order) or paginate (pagination.currentPage && pagination.maxRows)
             * @return {Promise} Returns a promise that will be fulfilled(Array of products and currency object) or rejected(error)
             */
            ProductsDao.prototype.listProducts = function (params) {
                var self = this,
                    defer = self.$q.defer(),
                    payload = '',
                    p;

                var addSimbolsToUrl = function () {
                    if (payload.length) {
                        payload += '&';
                    } else {
                        payload += '?';
                    }
                };

                if (params && (p = params.filter) && p.categoryId) {
                    addSimbolsToUrl();
                    payload += '&filterKey=' + p.categoryId;
                }

                if (params && (p = params.sort) && p.index && p.order) {
                    addSimbolsToUrl();
                    payload += 'sortIndex=' + p.index + '&sortOrder=' + p.order;
                }

                if (params && (p = params.pagination) && p.currentPage && p.maxRows) {
                    addSimbolsToUrl();
                    payload += 'currentPage=' + p.currentPage + '&maxRows=' + p.maxRows;
                }

                if (params && params.order >= 0 && params.order <= 1) {
                    addSimbolsToUrl();
                    payload += 'orderByPrice=' + params.order;
                }
                
                if (params && params.search && params.search.trim().length > 0) {
                    addSimbolsToUrl();
                    payload += 'search=' + params.search.trim();
                }

                self.httpGet(self.urlApiRestServer + (payload.length ? payload : ''))
                    .then(function (response) {
                        var data = response.data,
                            dataProducts = data.products,
                            retProducts = [];

                        _forEach(dataProducts, function (product) {
                            retProducts.push(new Product(product));
                        });

                        defer.resolve({
                            products: retProducts,
                            currency: data.currency,
                            postage: data.postage,
                            request: data.request
                        });
                    }, function (error) {
                        defer.reject(error);
                    });

                return defer.promise;
            };


            /**
             * Returns info about a specific product
             *
             * @method getProduct
             * @param {String} id Identification of the product
             * @return {Promise} Returns a promise that will be fulfilled(Product and currency object) or rejected(error)
             */
            ProductsDao.prototype.getProduct = function (id) {
                var defer = this.$q.defer();
                this.httpGet(this.urlApiRestServer + "/" + id)
                    .then(function (response) {
                        var data = response.data;
                        defer.resolve({
                            product: new Product(data.product),
                            currency: data.currency,
                            postage: data.postage
                        });

                    }, function (error) {
                        defer.reject(error);
                    });
                return defer.promise;
            };

            var create = function (url) {
                return new ProductsDao(url);
            };

            return{
                create: create
            };
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/plugins/products/factories/products-dao-factory.js